
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.683","height":"26.9"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 137","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}},[_c('g',{attrs:{"data-name":"Gruppe 136","transform":"translate(15.433 16.65)"}},[_c('circle',{attrs:{"data-name":"Ellipse 23","cx":"4.8","cy":"4.8","r":"4.8"}}),_c('path',{attrs:{"data-name":"Rechteck 71","d":"M4.795 3.2h.01v3.2h-.01z"}}),_c('path',{attrs:{"data-name":"Rechteck 72","d":"M3.2 4.795h3.2v.01H3.2z"}})]),_c('path',{attrs:{"data-name":"Pfad 105","d":"M18.55 16.959a9.341 9.341 0 00-1.212-.364c-2.263-.512-3.245-1.293-3.245-2.317v-.681a6.827 6.827 0 003.245-5.809V.65a3.531 3.531 0 01-2.588 1.661c-1.569 0-3.383-1.287-4.771-1.2-4.983.325-3.766 6.675-3.766 6.675a6.827 6.827 0 003.245 5.809h0v.681c0 1.024-.982 1.805-3.245 2.317-3.2.725-5.562 2.967-5.562 6.026v1.495h15.593a4.794 4.794 0 012.307-7.157z"}})])])
          )
        }
      }
    